import { System } from '@/app/models/system';
import { useAddSystemMutation, useUpdateSystemMutation } from '@/app/services/systemsApi';
import DrawerButtons from '@/components/common/DrawerButtons';
import ModalPageTitle from '@/components/common/ModalPageTitle';
import { Box, useTheme } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import FormField from '../baseForms/FormField';
import ModalLabel from '../common/ModalLabel';

interface NewEditSystemDrawerProps {
  selectItem: System | null;
  setDrawerOpen: (open: boolean) => void;
}

export default function NewEditSystemDrawer(props: NewEditSystemDrawerProps) {
  const { t } = useTranslation(['systems', 'common']);
  const theme = useTheme();
  const { selectItem, setDrawerOpen } = props;

  const [name, setName] = useState(selectItem?.name || '');
  const [description, setDescription] = useState(selectItem?.description || '');
  const [status, setStatus] = useState(selectItem?.active || false);

  const handleCancel = () => {
    setDrawerOpen(false);
  };

  const [update] = useUpdateSystemMutation();
  const [create] = useAddSystemMutation();

  const handleSubmit = async () => {
    console.log(selectItem);
    if (!name || !description) {
      return;
    }
    if (!selectItem) {
      setDrawerOpen(false);
      await toast.promise(
        create({ name, description }).unwrap(),
        {
          pending: t('common:processing.wait.a.moment') as string,
          success: t('system.added.sucessfully') as string,
          error: t('common:processing.failed') as string,
        },
        {
          position: toast.POSITION.TOP_RIGHT,
        },
      );
    } else {
      setDrawerOpen(false);
      await toast.promise(
        update({ id: selectItem.id, name, description }).unwrap(),
        {
          pending: t('common:processing.wait.a.moment') as string,
          success: t('system.updated.sucessfully') as string,
          error: t('common:processing.failed') as string,
        },
        {
          position: toast.POSITION.TOP_RIGHT,
        },
      );
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: 'calc(100vh - 24px)',
        maxHeight: 'calc(100vh - 24px)',
        flexGrow: 'inherit',
      }}
    >
      <Box sx={{ flexGrow: 1, overflowY: 'auto' }}>
        <ModalPageTitle title={selectItem ? t('edit.system') : t('add.system')} />
        <ModalLabel title={t('name')} />
        <FormField value={name} onChange={(e) => setName(e.target.value)} />
        <ModalLabel title={t('description')} />
        <FormField value={description} onChange={(e) => setDescription(e.target.value)} />
      </Box>

      <Box sx={{ mt: 'auto' }}>
        <DrawerButtons onSave={handleSubmit} onCancel={handleCancel} />
      </Box>
    </Box>
  );
}
